export class CustomPriceInfoModel {
    customPrice: string;
    customPriceComment: string;
}
